var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMailRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 12,
    height: 12,
    rx: 6,
    fill: "#DD7272"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.66699 3.83325H3.33366C2.96699 3.83325 2.67033 4.13325 2.67033 4.49992L2.66699 8.49992C2.66699 8.86659 2.96699 9.16659 3.33366 9.16659H8.66699C9.03366 9.16659 9.33366 8.86659 9.33366 8.49992V4.49992C9.33366 4.13325 9.03366 3.83325 8.66699 3.83325ZM8.66699 8.49992H3.33366V5.16659L6.00033 6.83325L8.66699 5.16659V8.49992ZM6.00033 6.16659L3.33366 4.49992H8.66699L6.00033 6.16659Z",
    fill: "#FFDDD2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailRed);
export default __webpack_public_path__ + "static/media/mail_red.63029f88576ca300224202b3beb5f826.svg";
export { ForwardRef as ReactComponent };